import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { gallerySections } from '@/mocks/galleryData';

// Pull a curated preview: first image from each of the first 6 sections
const previewImages = gallerySections.flatMap((s) => s.images.slice(0, 2)).slice(0, 6);

export default function GallerySection() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <section id="gallery" className="bg-[#0D0D0D] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 text-[#F57F25] text-xs font-bold tracking-widest uppercase mb-4">
            <div className="w-8 h-px bg-[#F57F25]"></div>
            {t('gallery_eyebrow')}
            <div className="w-8 h-px bg-[#F57F25]"></div>
          </div>
          <h2 className="text-4xl md:text-6xl font-black text-white uppercase tracking-tight mb-4">
            {t('gallery_headline')} <span className="text-[#F57F25]">{t('gallery_headline_accent')}</span>
          </h2>
          <p className="text-white/50 text-base max-w-xl mx-auto">
            {t('gallery_sub')}
          </p>
        </div>

        {/* Masonry-style Grid */}
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 space-y-4">
          {previewImages.map((img) => (
            <div
              key={img.id}
              className="break-inside-avoid relative group rounded-2xl overflow-hidden cursor-pointer"
              onClick={() => navigate('/gallery')}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-52 md:h-60 object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/50 transition-all duration-300 flex items-center justify-center">
                <div className="w-12 h-12 flex items-center justify-center bg-[#F57F25] rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 scale-75 group-hover:scale-100">
                  <i className="ri-zoom-in-line text-black text-xl"></i>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTAs */}
        <div className="text-center mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => navigate('/gallery')}
            className="inline-flex items-center gap-2 bg-[#F57F25] hover:bg-[#e06d15] text-black font-bold text-base px-8 py-4 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-image-line text-lg"></i>
            </div>
            {t('btn_view_full_gallery')}
          </button>
          <a
            href="https://instagram.com/bucara__burger"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 border-2 border-white/20 hover:border-[#F57F25] text-white/70 hover:text-[#F57F25] font-bold text-base px-8 py-4 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-instagram-line text-lg"></i>
            </div>
            {t('btn_follow_instagram')}
          </a>
        </div>
      </div>
    </section>
  );
}
